import styled from 'styled-components';

export const AssignTaskFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr auto;
  gap: 10px;
  width: 100%;
  min-width: 0;

  .field,
  .ui.dropdown,
  .ui.input {
    width: 100%;
    min-width: 0;
  }

  .ui.button {
    width: auto;
    min-width: 100px;
    max-width: 160px;
    justify-self: end;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    .field,
    .ui.dropdown,
    .ui.input,
    .ui.button {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      justify-self: stretch;
    }
  }
`;
